export default __webpack_public_path__ + "static/media/bull.38bbcea7.svg";